import Vue from 'vue';
import { getField, updateField } from 'vuex-map-fields';

const namespaced = true;

const state = {
  quizTitle: '',
  gradeId: null,
  courseId: null,
  status: true,
  quizQuestions: [],
  bySystem: false,
  timeLimit: ''
};

const getters = {
  getField,
  allFields(state) {
    return state;
  }
};

const mutations = {
  updateField,
  addQuestion(state) {
    state.quizQuestions.push({
      id: Math.random()
        .toString(36)
        .substr(2, 9),
      quizQuestionNo: state.quizQuestions.length + 1,
      quizTypeId: null,
      score: 0,
      quizQuestion: '',
      bySystem: false,
      imageUrl: null,
      quizAnswers: []
    });
  },
  removeQuestion(state, id) {
    const index = state.quizQuestions.findIndex(question => question.id == id);
    if (index !== -1) state.quizQuestions.splice(index, 1);

    state.quizQuestions.forEach((quiz, index) => (quiz.quizQuestionNo = index + 1));
  },
  setQuestions(state, payload) {
    Vue.set(state, 'quizQuestions', payload);
  },
  addAnswer(state, { id, payload }) {
    const index = state.quizQuestions.findIndex(question => question.id == id);
    if (index !== -1) state.quizQuestions[index].quizAnswers.push(payload);
  },
  updateAnswer(state, { id, payload }) {
    const index = state.quizQuestions.findIndex(question => question.id == id);
    if (index !== -1) Vue.set(state.quizQuestions[index], 'quizAnswers', payload);
  },
  CLEAR(state) {
    state.quizTitle = '';
    state.timeLimit = '';
    state.gradeId = null;
    state.courseId = null;
    state.status = true;
    Vue.set(state, 'quizQuestions', []);
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async upload({ commit }, file) {
    try {
      const fd = new FormData();
      fd.append('image', file);
      const {
        data: { data }
      } = await window.axios.post('/api/quiz/teacher/upload-image', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async destroyImage({ commit }, key) {
    return window.axios.get('/api/quiz/teacher/delete-image', { params: { key } });
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListStat({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/quiz/teacher/${id}/statistic`);
      return data;
    } catch (err) {
      throw err;
    }
  }
};

export default { namespaced, state, getters, mutations, actions };
